import axios, { AxiosResponse } from 'axios';
import { Event, FormData } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9091/api';
const PUBLIC_ENDPOINT = process.env.REACT_APP_PUBLIC_ENDPOINT || '/public';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  config.headers['Origin'] = window.location.origin;
  return config;
});

export const eventApi = {
  getEvent: async (eventSlug: string, price?: string, lang?: string | null): Promise<Event> => {
    const url = `${PUBLIC_ENDPOINT}/${eventSlug}${price ? `/${price}` : ''}${lang ? `?lang=${encodeURIComponent(lang)}` : ''}`;
    const response: AxiosResponse<Event> = await apiClient.get(url);
    return response.data;
  },

  getLanguages: async (): Promise<any[]> => {
    const response = await apiClient.get('/public-languages');
    return response.data;
  },

  getTranslations: async (lang: string): Promise<{ language: string; terms: Record<string, string> }> => {
    const response = await apiClient.get(`/public-translations?lang=${encodeURIComponent(lang)}`);
    return response.data;
  },

  submitForm: async (eventSlug: string, formData: FormData): Promise<any> => {
    const url = `${API_BASE_URL}/register`;
    const response: AxiosResponse = await apiClient.post(url, formData);
    return response.data;
  },

  processPayment: async (registrationId: number, paymentMethod: string): Promise<any> => {
    const url = `${PUBLIC_ENDPOINT}/payment`;
    const response: AxiosResponse = await apiClient.post(url, {
      subscription_id: registrationId,
      payment_method: paymentMethod
    });
    return response.data;
  },

  getInstalmentByToken: async (token: string): Promise<any> => {
    const response = await apiClient.get(`/pay-instalment/${token}`);
    return response.data;
  },

  getSubscriptionByToken: async (token: string): Promise<any> => {
    const response = await apiClient.get(`/pay-subscription/${token}`);
    return response.data;
  },

  startInstalmentPayment: async (token: string): Promise<any> => {
    const response = await apiClient.post(`/pay-instalment/${token}/start`);
    return response.data;
  },

  getCookieBanner: async (lang?: string | null): Promise<any> => {
    const response = await apiClient.get(`/public-cookie-banner${lang ? `?lang=${encodeURIComponent(lang)}` : ''}`);
    return response.data?.data ?? null;
  },
};

export default apiClient;